import { render } from "./ResolveTicket.vue?vue&type=template&id=ded1a34c"
import script from "./ResolveTicket.vue?vue&type=script&lang=js"
export * from "./ResolveTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__